<a [class.disabled]="disabled">
  {{ label | translate }}
</a>
